// Content of the North OS Meetings demo. Everything is invented: no real person, firm, client, property, city or
// agency. The world is a commercial leasing and acquisitions practice, far from any client's real matters (Jérémy,
// 23/09/2026: nothing may come from, or look like, a client's corpus — tests/meeting-demo-fiction.test.tsx holds it).

export type MeetingStatus = "ready" | "transcribing";

export type Meeting = {
  id: string;
  title: string;
  matter: string;
  meta: string[];
  summary: string;
  people: string[];
};

/** The call the demo records: absent from the poster, first in the list once it lands. */
export const NEW_MEETING: Meeting = {
  id: "quillmoor-landlord-call",
  title: "Flagship lease signing — landlord call",
  matter: "Quillmoor Arcade · 10-year lease",
  meta: ["ZOOM", "TODAY", "9:30AM", "5 ATTENDEES", "41MIN"],
  summary: "Rent terms agreed. The fit-out budget and the co-tenancy clause still gate the Sept 30 signing.",
  people: ["MR", "JL", "AK"],
};

/** Already processed meetings, newest first. */
export const PAST_MEETINGS: Meeting[] = [
  {
    id: "tollmere-loi",
    title: "Portfolio acquisition — buyer LOI redlines",
    matter: "Tollmere Logistics Park · purchase",
    meta: ["GOOGLE MEET", "SEP 16", "3:15PM", "4 ATTENDEES", "52MIN"],
    summary: "Buyer pushed back on the earn-out and the deposit schedule. Revised LOI due Monday.",
    people: ["DS", "MR"],
  },
  {
    id: "brackenfold-variance",
    title: "Planning variance — change-of-use timetable",
    matter: "Brackenfold Mill · office conversion",
    meta: ["TEAMS", "SEP 16", "11:00AM", "6 ATTENDEES", "33MIN"],
    summary: "The city accepts a phased opening. Parking study due before permits.",
    people: ["JL", "EP", "TK"],
  },
  {
    id: "quillmoor-estoppels",
    title: "Estoppel certificates — tenant review",
    matter: "Quillmoor Arcade · 10-year lease",
    meta: ["PHONE", "SEP 15", "4:40PM", "2 ATTENDEES", "18MIN"],
    summary: "Three tenants left to sign. Property manager to chase the rent roll.",
    people: ["MR", "AK"],
  },
  {
    id: "pellbrook-assignment",
    title: "Lease assignment — consent checklist",
    matter: "Pellbrook House · lease transfer",
    meta: ["ZOOM", "SEP 15", "1:00PM", "5 ATTENDEES", "45MIN"],
    summary: "Transfer slips two weeks pending landlord consent.",
    people: ["EP", "DS", "JL"],
  },
  {
    id: "closings-standup",
    title: "Weekly closings stand-up",
    matter: "Real estate group",
    meta: ["IN PERSON", "SEP 15", "8:42AM", "7 ATTENDEES", "24MIN"],
    summary: "Four signings this month. Quillmoor Arcade is on the critical path.",
    people: ["TK", "MR", "JL"],
  },
];

/** Recording prompt: the call in progress is the new meeting. */
export const PROMPT_META = ["ZOOM", "TODAY", "5 ATTENDEES"];

/** Recording timer, fast-forwarded to the call's 41 minutes while the demo records. */
export const TIMER_STEPS = ["00:00", "00:01", "00:02", "03:48", "11:05", "19:32", "27:14", "34:51", "41:06"];

/** Detail panel of the new meeting. The TL;DR is written sentence by sentence. */
export const TLDR = [
  "The landlord and the tenant's board signed off on the rent terms.",
  "Two items still gate the Sept 30 signing: the fit-out budget and the co-tenancy clause wording.",
  "The landlord's counsel returns its lease comments Thursday.",
];

export const TLDR_SOURCE = "GENERATED BY NORTH · CITES 3 SOURCES";

export type ActionItem = { text: string; owner: string; due: string };

export const ACTION_ITEMS: ActionItem[] = [
  { text: "Update the fit-out budget with the contractor", owner: "MR", due: "WED" },
  { text: "Get the co-tenancy clause redrafted", owner: "JL", due: "THU" },
  { text: "Send the lease comments to the client", owner: "YOU", due: "FRI" },
];
